import { http } from '@/http/axios.js'
// 部门树
export function getDeptTree() {
  return http({
    url: '/admin/dept/tree',
    method: 'get'
  })
}
// 角色列表
export function getRoleList(params) {
  return http({
    url: '/admin/role/page',
    method: 'GET',
    params
  })
}
// 管理员列表
export function getAdminList(params) {
  return http({
    url: `/admin/user/list`,
    method: 'get',
    params
  })
}
// 资方列表
export function getCapitalList(params) {
  return http({
    url: `/admin/capital/list`,
    method: 'get',
    params
  })
}
// 分类树
export function getGoodsCategoryTreeAPI(params) {
  return http({
    url: '/admin/goods/category/tree',
    method: 'get',
    params
  })
}
// store
export function getStoreListAPI(params) {
  return http({
    url: '/admin/store/page',
    method: 'get',
    params
  })
}
